import { render } from "./Index.vue?vue&type=template&id=3cc37bf9"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/classe/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cc37bf9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cc37bf9', __exports__)) {
    console.log('reload')
    api.reload('3cc37bf9', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=3cc37bf9", () => {
    console.log('re-render')
    api.rerender('3cc37bf9', render)
  })

}


export default __exports__